/**
 * @file スムーススクロール
 *
 */
'use strict';

/**
 * @classname SmoothScroll
 * @classdesc TOPへ戻る
 */
export default class SmoothScroll {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('SmoothScroll.constructor');
		this._$e = $e;
		$e.on('click', (e) => {this.onClick(e);});
	};

	/**
	 * @memberof SmoothScroll
	 */
	onClick(e){
		console.log('SmoothScroll.onClick');
		e.preventDefault();
		const href = this._$e.attr('href');
		const target = $(href === '#' || href === '' ? 'html' : href);
		const position = target.offset().top;
		$('html, body').animate({scrollTop: position}, 500, 'swing');
	}

}
